<template>
    <v-container container--fluid fill-height>
        <v-layout flex align-center justify-center>
            <div class="wrapper-reset-password">
                <h1 class="headline">Reset Password</h1>
                <v-layout v-show="errorShow">
                    <span class="error--text test-xs-center">{{message}}</span>
                </v-layout>
                <v-layout v-show="successShow">
                    <span class="success--text test-xs-center">{{message}}</span>
                </v-layout>
                <v-form>
                    <v-text-field
                        class="mb-4"
                        id="email"
                        name="email"
                        label="E-mail*"
                        v-model.trim="password_reset.email"
                        required
                        autofocus
                        placeholder="Please Enter"
                        :error-messages="errors($v.password_reset.email)"
                        @blur="$v.password_reset.email.$touch()"
                        @keydown.enter="reset_password"
                    >
                    </v-text-field>
                    <v-alert class="pa-2 mt-4" :value="$v.password_reset.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">Please fill out form correctly</span>
                    </v-alert>
                    <v-btn
                        id="btnResetPassword"
                        block
                        color="primary"
                        :loading="loading"
                        :disabled="loading"
                        @click="reset_password"
                    >
                        Send Password Reset Link
                    </v-btn>
                    <div class="text-center mt-4">
                        <span id="forgot-password-link">
                            <router-link to="/">Back to Login page</router-link>
                        </span>
                    </div>
                </v-form>
            </div>
        </v-layout>
    </v-container>
</template>


<script>
    import { validationMixin } from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import { valMessages, getValMessage } from '@/common/error-messages'
    import {mapState} from "vuex"
    import ApiService from "@/common/api.service"

    const validations = {
        password_reset: {
            email: { required, email }
        }
    }
    export default {
        name: 'ResetPassword',
        mixins: [validationMixin],
        validations,
        data: () => ({
            message: '',
            errorShow: false,
            successShow: false,
            loading: false,
            password_reset: {
                email: '',
                portal: 'employee',
            }
        }),
        methods: {
            reset_password() {
                this.$v.password_reset.$touch()
                if(!this.$v.password_reset.$invalid) {
                    this.loading = true
                    this.message = '';
                    ApiService.post('/auth/password_reset', this.password_reset)
                        .then(response => {
                            this.loading = false
                            this.password_reset.email = ''
                            this.message = "Check you e-mail for new password!"
                            this.errorShow = false
                            this.successShow = true
                            this.$v.$reset()
                        })
                        .catch(({data}) => {
                            this.loading = false
                            this.message = "E-mail does not exist in system!"
                            this.errorShow = true
                            this.successShow = false
                        })
                }
            },
            errors: getValMessage(valMessages)(validations)
        },
        computed: {
            ...mapState({
                server_errors: state => state.auth.errors
            })
        }
    }
</script>

<style lang="css">
    .wrapper-reset-password h1 {
        text-align: center;
        padding-bottom: 20px;
    }

    .wrapper-reset-password {
        width: 100%;
        max-width: 300px;
    }

    .btn__content {
        padding-top: 2px;
        height: fit-content;
    }
</style>
